import React from 'react';
import { getLocalizedText } from '@vp-dst/localization-util';

class SocialMediaInfoPanel extends React.Component{

    render(){

            return(
                <div style={{fontSize: 14, color:"white"}}>
                    <b>{getLocalizedText('social-media-tooltip-1')}</b>
                </div>
            );
    }
}

export default SocialMediaInfoPanel;


// WEBPACK FOOTER //
// ./src/components/SocialMediaInfoPanel.js